module.exports = __webpack_public_path__ + "img/RootnetTechnology.481d9750.jpg";